module.exports = ".mt-10 {\n  margin-top: 10rem !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/liquidacion-captura/liquidacion-captura-fondo-ahorro/liquidacion-captura-fondo-ahorro.component.scss
// module id = ./src/app/components/liquidacion-captura/liquidacion-captura-fondo-ahorro/liquidacion-captura-fondo-ahorro.component.scss
// module chunks = main